import { render, staticRenderFns } from "./ClientRequesters.vue?vue&type=template&id=1ae97e0b&scoped=true&"
import script from "./ClientRequesters.vue?vue&type=script&lang=js&"
export * from "./ClientRequesters.vue?vue&type=script&lang=js&"
import style0 from "./ClientRequesters.vue?vue&type=style&index=0&id=1ae97e0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae97e0b",
  null
  
)

export default component.exports